import { Api, Config } from './api'

export const ApiObterCargos = async () => {
   const { data } = await Api.get(`/cargos?ordenar=descricao&limite=1000`, Config())

   return data
}
